import { useLazyLoadQuery } from "react-relay"
import { fetchQuery, graphql } from "relay-runtime"
import { useAtossFileUploadQuery as useAtossFileUploadQueryType } from "@/modules/admin/capacity/services/__generated__/useAtossFileUploadQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const atossFileUploadQuery = graphql`
  query useAtossFileUploadQuery {
    atossFileUpload {
      id
      uploadedBy
      uploadedAt
      fileHash
      processedStatus
      processedOn
      processedError
    }
  }
`

export function useAtossFileUploadQuery() {
  const data = useLazyLoadQuery<useAtossFileUploadQueryType>(
    atossFileUploadQuery,
    {},
    {
      fetchPolicy: "network-only",
    },
  )

  return data
}

export function fetchAtossFileUpload() {
  return fetchQuery<useAtossFileUploadQueryType>(RelayEnvironment, atossFileUploadQuery, {}).subscribe({
    next: (response) => {
      return response.atossFileUpload
    },
  })
}
